<template>
    <modal-component v-model="modelValue">
        <div class="w-97 mt-2">
            <!-- Title -->
            <div
                class="
                    text-4xl
                    font-semibold
                    text-secondary
                    tracking-wide
                    mt-8
                    mb-12
                    flex
                    justify-center
                "
            >
                {{ title }}
            </div>

            <div
                class="mx-44 mb-6 text-secondary text-lg font-medium"
                v-if="done"
            >
                Your message has been delivered!
            </div>

            <form class="mx-44 mb-6" @submit.prevent="submit" v-else>
                <!-- offer -->
                <div class="mb-10 flex items-center">
                    <span class="icon-np-money text-secondary text-4xl"></span>
                    <message-input-component
                        id="offer"
                        type="number"
                        class="w-full"
                        v-model="form.offer"
                        placeholder="Your Offer"
                        :disabled="disableOffer"
                        :class="{
                            'text-gray-400': disableOffer,
                            'cursor-not-allowed': disableOffer,
                        }"
                        required
                    />
                </div>

                <div class="grid grid-cols-2 gap-4 mb-6">
                    <!-- first name -->
                    <div>
                        <message-input-component
                            id="firstname"
                            type="text"
                            class="w-72"
                            v-model="form.firstname"
                            placeholder="Your First Name"
                            required
                            autocomplete="firstname"
                        />
                    </div>

                    <!-- last name -->
                    <div>
                        <message-input-component
                            id="lastname"
                            type="text"
                            class="w-72"
                            v-model="form.lastname"
                            placeholder="Your Last Name"
                            required
                            autocomplete="lastname"
                        />
                    </div>
                </div>

                <!-- email -->
                <div class="mb-6">
                    <message-input-component
                        id="email"
                        type="email"
                        class="w-full"
                        v-model="form.email"
                        placeholder="Your Email Address"
                        required
                        autocomplete="email"
                    />
                </div>

                <div class="grid grid-cols-2 gap-4 mb-6">
                    <!-- phone -->
                    <div>
                        <message-input-component
                            id="phone"
                            type="text"
                            class="w-72"
                            v-model="form.phone"
                            placeholder="Your Phone Number"
                            required
                            autocomplete="phone"
                        />
                    </div>

                    <!-- dealer name -->
                    <div>
                        <message-input-component
                            id="dealer"
                            type="text"
                            class="w-72"
                            v-model="form.dealer"
                            placeholder="Dealer Name"
                            required
                        />
                    </div>
                </div>

                <!-- address -->
                <div class="mb-6">
                    <message-input-component
                        id="address"
                        type="text"
                        class="w-full"
                        v-model="form.address"
                        placeholder="Dealer Address"
                        required
                    />
                </div>

                <!-- message -->
                <div class="mb-8">
                    <textarea-component
                        id="message"
                        class="w-full h-28"
                        v-model="form.message"
                        placeholder="Type your message here"
                    />
                </div>

                <div class="flex justify-center">
                    <button
                        type="submit"
                        class="
                            inline-flex
                            bg-primary
                            rounded-full
                            text-sm text-white
                            px-9
                            py-2
                            font-semibold
                            tracking-wide
                            focus:outline-none focus:bg-secondary
                            hover:bg-secondary
                            transition-all
                            duration-500
                        "
                        :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing"
                    >
                        Confirm
                    </button>
                </div>
            </form>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "@/Components/Modal";
import MessageInputComponent from "@/Components/MessageInput";
import TextareaComponent from "@/Components/Textarea";

export default {
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        vehicle: {
            type: Object,
            required: true,
        },
        isBuyNow: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ModalComponent,
        MessageInputComponent,
        TextareaComponent,
    },
    data() {
        return {
            form: this.$inertia.form({
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                dealer: "",
                address: "",
                message: "",
                offer: null,
            }),
            done: false,
        };
    },
    watch: {
        modelValue(value) {
            this.done = false;
            this.form.reset();
            if (value && this.vehicle) {
                this.form.offer = this.vehicle.usd_reserve;
            }
        },
    },
    computed: {
        title() {
            return this.isBuyNow ? "Buy Now" : "Make an Offer";
        },
        disableOffer() {
            return this.isBuyNow && this.vehicle.usd_reserve;
        },
    },
    methods: {
        submit() {
            this.form.post("/" + this.vehicle.id + "/offer", {
                onSuccess: () => this.form.reset(),
                onFinish: () => {
                    this.done = true;
                },
            });
        },
        cancel() {
            this.$emit("cancel");
        },
    },
};
</script>
